/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipTypeGridItemViewModelPaginatedResponse } from "../types/ScholarshipTypeGridItemViewModelPaginatedResponse.ts";
import { scholarshipTypeGridItemViewModelSchema } from "./scholarshipTypeGridItemViewModelSchema.ts";

export const scholarshipTypeGridItemViewModelPaginatedResponseSchema = z.object(
  {
    data: z
      .array(z.lazy(() => scholarshipTypeGridItemViewModelSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  },
) as unknown as ToZod<ScholarshipTypeGridItemViewModelPaginatedResponse>;
